var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5825 26.6172C15.9381 28.3003 18.6241 27.8705 19.379 25.8497L27.6371 3.74324C28.4687 1.51713 26.2822 -0.649634 24.043 0.181615L1.81478 8.43346C-0.218153 9.18815 -0.644312 11.8576 1.05383 13.2L5.35903 16.6032C6.02828 17.1323 6.97442 17.14 7.65237 16.622L18.0723 8.66041C18.3706 8.43248 18.7929 8.45972 19.059 8.72406C19.3251 8.98841 19.3525 9.40782 19.1231 9.70413L11.1101 20.0512C10.5875 20.726 10.5965 21.6681 11.1319 22.3329L14.5825 26.6172Z",
    fill: "#A64EFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.c1f18ffcdc76df4e2e28b644ee3ae6fb.svg";
export { ForwardRef as ReactComponent };